<script lang="ts" setup>
import { computed, onMounted, ref, useTemplateRef } from '#imports';
import type { TxtMsgVO } from '@core/types/im';
import { watchElementVisible } from '../../composables/watch-element-visible';
import ImMsgBase from './ImMsgBase.vue';

interface Props {
  msg: TxtMsgVO;
}

const { msg } = defineProps<Props>();
const txtRef = useTemplateRef('txt');

const emit = defineEmits(['retry', 'read']);

function handleRetry() {
  emit('retry');
}
function handleRead() {
  emit('read');
}

onMounted(() => {
  if (!msg.isMine && msg.readStatus === 0) {
    watchElementVisible(txtRef, handleRead);
  }
});
</script>

<template>
  <ImMsgBase
    :recall="msg.msgBody.recall"
    :avatar="msg.avatar"
    :show-datetime="msg.showDatetime"
    :time="msg.msgTime"
    :placement="msg.placement"
    :loading="msg.loading"
    :error="msg.error"
    :sensitive="msg.sensitive"
    @retry="handleRetry"
  >
    <div ref="txt" class="whitespace-pre-wrap break-words">
      {{ msg.msgBody.txtMsg.txt }}
    </div>
  </ImMsgBase>
</template>

<style scoped></style>
